module.exports = __webpack_public_path__ + "static/media/AMANAHJEDDAH.289523a2.png";